import { render } from "./TopicView.vue?vue&type=template&id=9843eeae"
import script from "./TopicView.vue?vue&type=script&lang=js"
export * from "./TopicView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__